<template lang="pug">
  b-modal#updateMaintenanceSchedule(
  ref="updateMaintenanceSchedule"
  :title="$t('ui.combine.update_maintenance_schedule')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.provider_code')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="provider_code"
          required
          type="text"
          :dirty="$v.provider_code.$dirty"
          :error="$v.provider_code.$error"
          v-model.trim.lazy="$v.provider_code.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.provider_code" :name="$t('ui.provider_code')")
      b-form-group(:label="$t('ui.provider_name')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="provider_name"
          required
          type="text"
          :dirty="$v.provider_name.$dirty"
          :error="$v.provider_name.$error"
          v-model.trim.lazy="$v.provider_name.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.provider_name" :name="$t('ui.provider_name')")
      b-form-group(:label="$t('ui.date')").mb-0
        DateTimeRangePicker(:value="dateRangeSlots" @update="getDataSlots" ref="dateRangeSlots" :removePrepend="true")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import DateTimeRangePicker from "@/library/DateTimeRangePicker.vue";
// import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    DateRangePicker,
    DateTimeRangePicker
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      provider_code: "",
      provider_name: "",
      start_date: null,
      end_date: null,
      loading: false,
      dateRangeSlots: {
        startDate: null,
        endDate: null,
      },
      feedback: {
        success: true,
        status: ""
      },
      locale: {
        format: 'YYYY-MM-DD HH:mm:ss',
        useCurrent: false,
        showClose: true,
      },
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    today() {
      return this.$moment(new Date).format('YYYY-MM-DD');
    },
    todayWithTime() {
      let time = '00:00:00';
      return this.$moment(this.today+ " " + time).format('YYYY-MM-DD HH:mm:ss');
    },
    tomorrow() {
      return this.$moment(new Date).add(1, 'days').format('YYYY-MM-DD');
    },
    tomorrowWithTime() {
      let time = '00:00:00';
      return this.$moment(this.tomorrow+ " " + time).format('YYYY-MM-DD HH:mm:ss');
    },
  },
  validations: {
    provider_code: {
      required,
      maxLength: maxLength(20)
    },
    provider_name: {
      required,
      maxLength: maxLength(50)
    }
  },
  methods: {
    getDataSlots(currentValue) {
      this.dateRangeSlots.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD HH:mm:ss');
      this.dateRangeSlots.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD HH:mm:ss');
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.providerMaintenanceGlobalSetUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          provider_code: this.provider_code.trim(),
          // provider_name: this.provider_name.trim(),
          start_time: this.dateRangeSlots.startDate,
          end_time: this.dateRangeSlots.endDate,
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.updateMaintenanceSchedule.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "update_maintenance_schedule", this.feedback.status);
                  this.$refs.updateMaintenanceSchedule.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.provider_code = this.item.provider_code;
      this.provider_name = this.item.provider_name;
      this.start_date = this.todayWithTime;
      this.end_date = this.tomorrowWithTime;
      this.getDataSlots({
        startDate: this.start_date,
        endDate: this.end_date
      });
      // this.$refs.start_date.$el.focus();
    }
  }
};
</script>
